import React, { useState, useEffect } from 'react'
import { Chart } from 'primereact/chart'
import { useAppSelector } from '../../../store/hooks'
import { chartColorVariants } from './chartsUtil'

const LineChart = ({ data }) => {
    const theme = useAppSelector((state) => state.theme.theme)

    const [chartData, setChartData] = useState({})
    const [chartOptions, setChartOptions] = useState({})

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement)
        const textColor = documentStyle.getPropertyValue(
            theme === 'dark' ? '--bs-white' : '--bs-black'
        )
        const textColorSecondary = documentStyle.getPropertyValue(
            '--text-color-secondary'
        )
        const surfaceBorder =
            documentStyle.getPropertyValue('--bs-border-color')

        const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.6,
            plugins: {
                legend: {
                    labels: {
                        color: textColor,
                    },
                },
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary,
                    },
                    grid: {
                        color: surfaceBorder,
                    },
                },
                y: {
                    ticks: {
                        color: textColorSecondary,
                    },
                    grid: {
                        color: surfaceBorder,
                    },
                },
            },
        }

        let finalisedChartData = data
        const dataSets = data?.['datasets'] || []

        for (const i in dataSets) {
            finalisedChartData['datasets'][i]['type'] = 'line'
            finalisedChartData['datasets'][i]['borderWidth'] = 1.5
            finalisedChartData['datasets'][i]['fill'] = true
            finalisedChartData['datasets'][i]['tension'] = 0.5

            const colorVariant = chartColorVariants[i]

            if (colorVariant) {
                finalisedChartData['datasets'][i]['borderColor'] =
                    documentStyle.getPropertyValue('--bs-' + colorVariant)
                finalisedChartData['datasets'][i]['backgroundColor'] =
                    documentStyle.getPropertyValue('--bs-' + colorVariant) +
                    '10'
            }
        }

        setChartData(finalisedChartData)
        setChartOptions(options)
    }, [theme, data])

    return <Chart type="line" data={chartData} options={chartOptions} />
}

export default LineChart
